{
    "ModalTitleMc": "Einen Anruf tätigen",
    "ModalTitleTo": "Anruf senden an",
    "ModalTitleMcc": "Anfrage weiterleiten an",
    "SubTitle": "Telefonnummer wählen",
    "SelectLabel": "Telefonnummer:",
    "SelectPlaceholder": "zB 01234567899",
    "SelectNoItems": "Unbekannte Nummer",
    "FooterHelp": "Hilfe",
    "FooterOk": "OK",
    "FooterClose": "Nah dran",
    "CallTargetting_Description": "Wählen Sie ein internes Zielgerät aus der Liste aus oder geben Sie die Zielrufnummer manuell ein.",
    "NAME": "CallTargetting"
}